import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "974bd4c8-b798-4f00-b005-ac5178077b9d",
    content: "Mathematically replicate parts<br>of human auditory processing",
    options: {},
  },
  { id: "bad4059f-17a2-4542-82de-647c83f03fbd", content: "Explain functioning of human hearing", options: {} },
  {
    id: "2df0aadd-d672-455f-bc25-be0dc52b39ed",
    content: "Replicate human perception<br>as precisely as possible",
    options: {},
  },
  {
    id: "ccfaa8a5-feb2-42b4-84a3-d814ce864f0f",
    content: "Estimate how any deficit in one part of<br>the hearing can affect the overall system",
    options: {},
  },
  { id: "8b2a5a6c-80a7-4d37-998a-fce583e23643", content: "Calculate loudness of a sound", options: {} },
  { id: "0a8680ab-3910-480e-8cae-d6a5a9c815c2", content: "Calculate SPL of a sound", options: {} },
];

export const task: Task = {
  id: "2605ad36-4911-4266-aa58-1f0c486519d5",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    shuffle: true,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: [
    "974bd4c8-b798-4f00-b005-ac5178077b9d",
    "bad4059f-17a2-4542-82de-647c83f03fbd",
    "2df0aadd-d672-455f-bc25-be0dc52b39ed",
    "ccfaa8a5-feb2-42b4-84a3-d814ce864f0f",
    "8b2a5a6c-80a7-4d37-998a-fce583e23643",
  ],
};
